import URLField from './urlfield'
import PropTypes from 'prop-types'
import React from 'react'

const URLFieldContainer = React.forwardRef((props, ref) => {

  const componentRef = React.useRef()

  React.useImperativeHandle(ref, () => ({
    clear: () => componentRef.current._handleClear(),
    focus: () => componentRef.current._handleFocus()
  }))

  return <URLField ref={ componentRef } {...props} />

})

export default URLFieldContainer
